// Adapted from https://github.com/brigade/react-simple-pie-chart
import React from 'react';

export default function PieChart({
  slices,
  size,
  className,
  selectedSlice,
  selectionScale,
  onHoverSlice,
}) {
  const center = size / 2;
  const radius = center - 1;
  const radCircumference = Math.PI * 2;
  const total = slices.reduce((totalValue, { value }) => totalValue + value, 0);
  const addedSize = radius * selectionScale - radius;
  let radSegment = 0;
  let lastX = radius;
  let lastY = 0;

  return (
    <svg
      viewBox={`-${addedSize} -${addedSize} ${size + 2 * addedSize} ${
        size + 2 * addedSize
      }`}
      className={className}
    >
      <defs>
        <mask id="donut">
          <rect
            x={-addedSize}
            y={-addedSize}
            width={size + 2 * addedSize}
            height={size + 2 * addedSize}
            fill="white"
          />
          <circle r={radius / 1.5} cx={center} cy={center} fill="black" />
        </mask>
      </defs>
      <g transform={`rotate(-90 ${center} ${center})`} mask="url(#donut)">
        {slices.map(({ color, value }, index) => {
          if (value === total) {
            return (
              <circle
                key={color}
                r={radius}
                cx={center}
                cy={center}
                fill={color}
                onMouseOver={onHoverSlice}
              />
            );
          }

          if (value === 0) {
            return false;
          }

          const valuePercentage = value / total;

          // Should the arc go the long way round?
          const longArc = valuePercentage <= 0.5 ? 0 : 1;

          radSegment += valuePercentage * radCircumference;
          const nextX = Math.cos(radSegment) * radius;
          const nextY = Math.sin(radSegment) * radius;

          // d is a string that describes the path of the slice.
          // The weirdly placed minus signs [eg, (-(lastY))] are due to the fact
          // that our calculations are for a graph with positive Y values going up,
          // but on the screen positive Y values go down.
          const d = [
            `M ${center},${center}`,
            `l ${lastX},${-lastY}`,
            `a${radius},${radius}`,
            '0',
            `${longArc},0`,
            `${nextX - lastX},${-(nextY - lastY)}`,
            'z',
          ].join(' ');

          lastX = nextX;
          lastY = nextY;

          const scale = index === selectedSlice ? selectionScale : 1;
          return (
            <path
              id={`path-${index}`}
              key={color}
              d={d}
              fill={color}
              transform={`matrix(${scale}, 0, 0, ${scale}, ${
                center - scale * center
              }, ${center - scale * center})`}
              onMouseOver={onHoverSlice}
              onMouseOut={onHoverSlice && onHoverSlice.bind(null, null)}
            />
          );
        })}
      </g>
      <circle r={radius / 1.5} cx={center} cy={center} fill="transparent" />
    </svg>
  );
}

PieChart.defaultProps = {
  size: 100,
  className: '',
  selectionScale: 1.15,
};
